import { FC } from "react";
import { Box, Button as DefaultButton, ButtonProps } from "@mui/material";

interface Props extends ButtonProps {
  label: string;
  icon?: JSX.Element;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Button: FC<Props> = ({
  label,
  icon,
  variant,
  className,
  color,
  onClick,
  sx,
  ...otherProps
}) => {
  return (
    <DefaultButton
      variant="contained"
      className={className ?? ""}
      sx={{
        bgcolor: color === "primary" ? "primary.main" : "#fff",
        color: color === "primary" ? "#fff" : "#000",
        padding: "0.75rem 2rem",
        fontSize: 18,
        lineHeight: "22px",
        borderRadius: 0,
        textTransform: "none",
        ":hover": {
          bgcolor: color === "primary" ? "#fff" : "#0031d9",
          color: color === "primary" ? "#0031d9" : "#fff",
        },
        ...sx,
      }}
      onClick={onClick}
      {...otherProps}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          wordBreak: "none"
        }}
      >
        {icon}
        {label}
      </Box>
    </DefaultButton>
  );
};

export default Button;
